var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
var WebSocketService = (function () {
    function WebSocketService() {
        // Subjects para los eventos de WebSocket
        this.onOpen = new Subject();
        this.onMessage = new Subject();
        this.onClose = new Subject();
        this.onError = new Subject();
    }
    WebSocketService.prototype.connect = function (url) {
        var _this = this;
        this.socket = new WebSocket(url);
        //console.log("websocket " + JSON.stringify(this.socket));
        this.socket.onopen = function (event) {
            //console.log('WebSocket connection established');
            _this.onOpen.next(event); // Emitir el evento de apertura
        };
        this.socket.onmessage = function (event) {
            //console.log("mensaje: " + event.data);
            var data = JSON.parse(event.data);
            _this.onMessage.next(data); // Emitir el evento de mensaje recibido
        };
        this.socket.onclose = function (event) {
            //console.log('WebSocket connection closed', event);
            _this.onClose.next(event); // Emitir el evento de cierre
        };
        this.socket.onerror = function (error) {
            //console.log('WebSocket error', error);
            _this.onError.next(error); // Emitir el evento de error
        };
    };
    WebSocketService.prototype.send = function (message) {
        if (this.socket && this.socket.readyState === WebSocket.OPEN) {
            //console.log('WebSocket send ', message);
            this.socket.send(JSON.stringify(message));
        }
        else {
            //console.log('WebSocket is not open. Unable to send message.');
        }
    };
    WebSocketService.prototype.disconnect = function () {
        if (this.socket) {
            this.socket.close();
        }
    };
    return WebSocketService;
}());
WebSocketService = __decorate([
    Injectable(),
    __metadata("design:paramtypes", [])
], WebSocketService);
export { WebSocketService };
//# sourceMappingURL=websocket.service.js.map